import * as yup from "yup";
export const ExportDataInitialValues = {
    exportOrganizations: true,
    exportOrganizationAdmins: true,
    exportProviders: true,
    exportCaseManagers: true,
    exportCaregivers: false,
    exportLocations: false,
    exportPhoneNumber: true,
    exportEmail: true
};
export const ExportDataSchema = yup.object().shape({
    exportOrganizations: yup.boolean().required(),
    exportOrganizationAdmins: yup.boolean().required(),
    exportProviders: yup.boolean().required(),
    exportCaseManagers: yup.boolean().required(),
    exportCaregivers: yup.boolean().required(),
    exportLocations: yup.boolean().required(),
    exportPhoneNumber: yup.boolean().required(),
    exportEmail: yup.boolean().required()
});
